import React, { useCallback } from 'react';
import { Sample } from 'types';
import { useModalContext } from 'contexts/ModalContext/ModalContext';
import { useCollectionModalContext } from 'modals/CollectionModal/CollectionModalContext';

const useDeleteCollectionSampleButton = ({
    samples,
    onClick,
}: {
    samples: Sample[];
    onClick?: () => void;
}): {
    handleClick: (event: React.MouseEvent) => void;
} => {
    const { openModal } = useModalContext();
    const { setSamplesToDelete } = useCollectionModalContext();

    const handleClick = useCallback(() => {
        setSamplesToDelete(samples);
        openModal.removeSamplesFromCollection();
        onClick && onClick();
    }, [openModal, setSamplesToDelete, samples]);

    return {
        handleClick,
    };
};

export default useDeleteCollectionSampleButton;
